module.exports = __webpack_public_path__ + "static/media/mobile-screens.8edcda75.png";